/**
 * An organization's linkage switches (Feature 71). Platform administrators
 * only. Each template comes with the organization's switch and the steps
 * no agent of the organization binds, which a run would skip `not_bound`.
 */
import { apiGet, apiPut } from '../client.js';
import type { LinkageRun, OrganizationLinkage } from '../types.js';

function base(orgId: string): string {
  return `/api/v1/admin/organizations/${encodeURIComponent(orgId)}/linkages`;
}

export function listOrganizationLinkages(orgId: string): Promise<OrganizationLinkage[]> {
  return apiGet<OrganizationLinkage[]>(base(orgId));
}

/** The organization's last 20 runs of one template, newest first (Feature 74 D8). */
export function listOrganizationLinkageRuns(orgId: string, key: string): Promise<LinkageRun[]> {
  return apiGet<LinkageRun[]>(`${base(orgId)}/${encodeURIComponent(key)}/runs`);
}

/**
 * The switch for one template; on a schedule, the organization's own cron
 * too: null returns it to the template's default, and leaving it out keeps
 * the one set (Feature 77 D11).
 */
export function setOrganizationLinkage(
  orgId: string,
  key: string,
  enabled: boolean,
  cronExpression?: string | null,
): Promise<OrganizationLinkage> {
  const body =
    cronExpression === undefined ? { enabled } : { enabled, cron_expression: cronExpression };
  return apiPut<OrganizationLinkage>(`${base(orgId)}/${encodeURIComponent(key)}`, body);
}
